/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LightbulbIcon16Regular = forwardRef('LightbulbIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.794 6.1a4.206 4.206 0 1 1 6.869 3.255c-.386.316-.728.748-.896 1.273a.75.75 0 0 0 1.429.457c.062-.192.204-.395.417-.57a5.706 5.706 0 1 0-7.225 0c.212.175.354.378.416.57a.75.75 0 0 0 1.429-.457c-.168-.525-.51-.957-.895-1.273A4.196 4.196 0 0 1 3.794 6.1Z" }),
        React.createElement("path", { d: "M5.591 13.538h4.827a.75.75 0 0 0 0-1.5H5.59a.75.75 0 0 0 0 1.5Z" }),
        React.createElement("path", { d: "M5.996 15.243a.75.75 0 0 1 .75-.75h2.508a.75.75 0 0 1 0 1.5H6.746a.75.75 0 0 1-.75-.75Z" }),
        React.createElement("path", { d: "M8.75 6a.75.75 0 0 0-1.5 0v4a.75.75 0 0 0 1.5 0V6Z" })));
});
